import { gql } from '@apollo/client'

export const CREATE_KUDOS = gql`
  mutation CreateKudos($employeeId: HashedId!, $description: String!) {
    createKudos(employeeId: $employeeId, description: $description)
  }
`

export const DELETE_KUDOS = gql`
  mutation DeleteKudos($kudosId: HashedId!) {
    deleteKudos(kudosId: $kudosId)
  }
`

export const CREATE_ATTENTION_POINT = gql`
  mutation CreateAttentionPoint($employeeId: HashedId!, $description: String!) {
    createAttentionPoint(employeeId: $employeeId, description: $description)
  }
`

export const DELETE_ATTENTION_POINT = gql`
  mutation DeleteAttentionPoint($attentionPointId: HashedId!) {
    deleteAttentionPoint(attentionPointId: $attentionPointId)
  }
`

export const UPDATE_MY_OPT_OUT_VALUE = gql`
  mutation UpdateMyOptOutValue($newOptOutValue: Boolean!) {
    updateMyOptOutValue(newOptOutValue: $newOptOutValue)
  }
`

export const UPDATE_EMPLOYEE_OPT_OUT_VALUE = gql`
  mutation UpdateEmployeeOptOutValue($employeeId: HashedId!, $newOptOutValue: Boolean!) {
    updateEmployeeOptOutValue(employeeId: $employeeId, newOptOutValue: $newOptOutValue)
  }
`

// ////////
// SETTINGS
// ////////

export const EDIT_KUDOS_LEGAL_ENTITY_VISIBILITY = gql`
  mutation SetKudosLegalEntityVisibility($kudosLegalEntityVisibilityInput: KudosLegalEntityVisibilityInput!) {
    setKudosLegalEntityVisibility(kudosLegalEntityVisibilityInput: $kudosLegalEntityVisibilityInput)
  }
`

export const CREATE_OR_EDIT_KUDOS_COMPANY_COUNTRY_VISIBILITY = gql`
  mutation SetKudosCompanyCountryVisibility($kudosCompanyCountryVisibilityInput: KudosCompanyCountryVisibilityInput!) {
    setKudosCompanyCountryVisibility(kudosCompanyCountryVisibilityInput: $kudosCompanyCountryVisibilityInput)
  }
`

export const DELETE_KUDOS_COMPANY_COUNTRY_VISIBILITY = gql`
  mutation DeleteKudosCompanyCountryVisibility($kudosCompanyCountryVisibilityId: HashedId!) {
    deleteKudosCompanyCountryVisibility(kudosCompanyCountryVisibilityId: $kudosCompanyCountryVisibilityId)
  }
`
